const getTimeFromDayMonthYear = (
  values: Partial<Maybe<DayMonthYear>>,
): number | undefined => {
  const { day, month, year } = values ?? {};
  if (!day || !month || !year) {
    return undefined;
  }
  const timestamp = Date.UTC(year, month - 1, day, 0, 0) / 1000;
  return timestamp;
};

export default getTimeFromDayMonthYear;
